import {
  Col,
  Input,
  Row,
  Form,
  DatePicker,
  Select,
  TimePicker,
  Button,
  message,
  Radio,
  Checkbox,
} from "antd";
import React, { useEffect, useState } from "react";
import enrollmentServices from "../../../Services/enrollmentServices";
import CommonFunctions from "../../Shared/CommonFunctions";
import dayjs from "dayjs";
import AppointmentService from "../../../Services/AppointmentService";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserWalletDetails } from "../../../Redux/actions/UserActions";

function NewPatientInvite({
  paymentType,
  setPaymentType,
  appointmentsList,
  handleOk,
  form,
  handleKeyPress,
  paymentReceived,
  setPaymentReceived,
  callType,
  setCallType,
  accountDetails,
}) {
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [save, setSave] = useState(false);
  const [endTime, setEndTime] = useState(null);
  const [submitType, setSubmitType] = useState(null);
  const [applyRegFee, setApplyRegFee] = useState(true);
  const [showFields, setShowFields] = useState(false);
  const [showFields2, setShowFields2] = useState(false);
  const [consReason, setConsReason] = useState("");
  const [consCode, setConsCode] = useState("");
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const { walletDetails, walletAmount } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await AppointmentService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleConsReasonChange = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const onFeeCheckBoxChage = () => {
    setApplyRegFee(!applyRegFee);
  };

  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const handleCallTypeChange = (value) => {
    setCallType(value);
    if (value === "APPT_INPERSON") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.inpersonFee
          ? loginResultObject.user.inpersonFee
          : 0,
      });
    } else if (value === "APPT_VIDEO") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.videoFee
          ? loginResultObject.user.videoFee
          : 0,
      });
    } else if (value === "APPT_HOMEVISIT") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.homeVisitFee
          ? loginResultObject.user.homeVisitFee
          : 0,
      });
    }
  };

  const handleCancelClick = () => {
    setPaymentType("Cash");
    setCallType("APPT_VIDEO");
    handleOk();
  };
  const handleClick = async (payload) => {
    payload.consultationReason = consReason;
    payload.complaintCode = consCode;

    payload.createdDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    payload.modifiedDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    payload.appointmentDate = CommonFunctions.convertDate(
      payload.appointmentDate
    );

    payload.firstName =
      payload.firstName.charAt(0).toUpperCase() + payload.firstName.slice(1);

    payload.lastName = payload?.lastName
      ? payload?.lastName.charAt(0).toUpperCase() + payload?.lastName.slice(1)
      : "";
    payload.startTime = dayjs(payload.startTime).local().format("hh:mm A");
    payload.endTime = dayjs(payload.endTime).local().format("hh:mm A");
    payload.createdBy = loginResultObject.user.userId;

    payload.modifiedBy = loginResultObject.user.userId;
    payload.dob = payload.dob
      ? dayjs(payload?.dob, "MM/DD/YYYY").format("MM/DD/YYYY")
      : "";
    payload.userId = loginResultObject.user.userId;
    payload.account_Id = loginResultObject.user.account_Id;
    payload.clinic_Id = loginResultObject.user.clinic_Id;
    payload.patientType = "N";
    payload.specialityCode = loginResultObject.user?.specialityCode;
    payload.serviceName =
      payload.serviceCode === "APPT_VIDEO"
        ? "Video Consultation"
        : payload.serviceCode === "APPT_INPERSON"
        ? "Inperson Consultation"
        : payload.serviceCode === "APPT_HOMEVISIT"
        ? "Home Visit Consultation"
        : "";

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (payload.email && !emailRegex.test(payload.email)) {
      message.error("Enter a valid email in the send invite");
      return;
    }

    payload.patientRegFeeYN = applyRegFee ? "Y" : "N";
    payload.patientRegFee = applyRegFee ? payload.patientRegFee : 0;

    payload.totalAmount =
      parseFloat(payload.patientRegFee) + parseFloat(payload.consultationFee);

    if (submitType === "1") {
      setSave(true);
      payload.status = 0;
      payload.paymentReceived = "N";
      payload.paymentType = "Digital";
      let data = JSON.stringify(payload);

      CommonFunctions.NewPatientPayment(data)
        .catch((error) => {
          message.error("An Error occurred, try again");
        })
        .finally(() => {
          setSave(false);
        });
    } else if (submitType === "2") {
      payload.paymentType = paymentType;
      if (payload.paymentType == "Cash" && !paymentReceived) {
        message.error("Confirm Payment received by clicking the check box");
        setSave(false);
        return;
      }
      if (payload.paymentType == "VirtualCash") {
        payload.walletId = walletDetails.walletId;
        payload.txnType = "DEBIT";
        payload.status = 1;
        payload.paymentReceived = "Y";
        if (walletAmount < payload.totalAmount) {
          message.error("Required Amount not available in the wallet");
          setSave(false);
          return;
        }
      }
      setSave(true);
      try {
        payload.paymentReceived = paymentReceived ? "Y" : "N";
        payload.status = 1;
        let data = JSON.stringify(payload);
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          message.error(result.data.message);
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("New Patient Registration Successfull");
          message.success("Invitation sent Successfully");
          appointmentsList();
          handleOk();
        }
      } catch (error) {
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    } else if (submitType == "3") {
      setSave(true);
      try {
        if (
          payload.paymentType == "Digital" &&
          payload.paymentConsultation == "AC"
        ) {
          message.error(
            "Share payment link is not available for After Consultation"
          );
          return;
        }
        payload.status = 0;
        payload.paymentType = "Share_Link";
        let data = JSON.stringify(payload);
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          message.error(result.data.message);
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("New Patient Registration Successfull");
          message.success("Payment Link and invitation sent Successfully");
          appointmentsList();
          handleOk();
        }
      } catch (error) {
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    }
  };

  const handleStartTimeChange = (time) => {
    if (time) {
      const endTime = dayjs(time).add(15, "minutes");
      setEndTime(endTime);
      form.setFieldsValue({ endTime });
    } else {
      setEndTime(null);
    }
  };

  const genders = [
    {
      value: "M",
      label: "Male",
    },
    {
      value: "F",
      label: "Female",
    },
  ];

  const disabledFutureDate = (current) => {
    return current && current > new Date().setHours(23, 59, 59, 999);
  };

  const onPaymentStatusChange = () => {
    setPaymentReceived(!paymentReceived);
  };

  const onPaymentTypeChange = (value) => {
    setPaymentType(value);
    if (value === "Cash") {
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "VirtualCash") {
      let payload = {
        userId: loginResultObject.user.userId,
        account_Id: loginResultObject.user.account_Id,
        clinic_Id: loginResultObject.user.clinic_Id,
      };
      dispatch(fetchUserWalletDetails(payload));
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "Digital") {
      form.setFieldsValue({ paymentConsultation: "BC" });
      setPaymentReceived(false);
    } else {
      form.setFieldsValue({ paymentConsultation: null });
      setPaymentReceived(false);
    }
  };

  const handleSubmitType = (type) => {
    setSubmitType(type);
  };

  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

  return (
    <div className="my-2">
      {save && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <Form
        className="formDesign mt-3"
        layout="vertical"
        form={form}
        onFinish={handleClick}
        initialValues={{
          serviceCode: "APPT_VIDEO",
          paymentType: "Cash",
          consultationFee: loginResultObject.user.videoFee,
          paymentConsultation: "BC",
          appointmentDate: dayjs(),
          patientRegFee: accountDetails.patientRegFee,
          startTime: dayjs(),
          endTime: dayjs().add(15, "minutes"),
        }}
      >
        <div className="rounded-lg bg-white p-3 ">
          <div className="flex justify-between">
            {" "}
            <p className="">Personal Details</p>
            <div className="">
              <span
                className="px-2 text-blue-500 cursor-pointer"
                onClick={() => {
                  setShowFields(!showFields);
                }}
              >
                {!showFields ? "More" : "Hide"}
              </span>
            </div>
          </div>
          <Row gutter={24} className="mt-2">
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                  Name <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter First Name!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Full Name"
                    className="mt-1  rounded-md px-4 py-2"
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-[#A0A2A3] text-xs">
                  Mobile <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number!",
                    },
                  ]}
                >
                  <Input
                    className="w-full mt-1 rounded-md px-4 py-2 "
                    type="text"
                    maxLength={15}
                    onKeyDown={handleKeyPress}
                    placeholder="Mobile"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            {showFields && (
              <>
                <Col span={12}>
                  <div className="relative mt-6">
                    <span className="absolute -top-2 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Email ID
                    </span>
                    <Form.Item name="email">
                      <Input
                        type="text"
                        placeholder="Email"
                        className="w-full  rounded-lg px-4 py-2 "
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12}>
                  <div className="relative mt-6">
                    <span className="absolute -top-2 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Emergency Contact
                    </span>
                    <Form.Item name="emergencyContact">
                      <Input
                        type="text"
                        placeholder="Emergency Contact"
                        className="w-full  rounded-md px-4 py-2  "
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      D.O.B
                    </span>
                    <Form.Item name="dob">
                      <DatePicker
                        className="w-full mt-1  rounded-md px-4 py-2 text-xs"
                        format={"DD/MM/YYYY"}
                        disabledDate={disabledFutureDate}
                        placeholder="D.O.B"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Gender
                    </span>
                    <Form.Item name="gender">
                      <Select
                        className="w-full rounded-md mt-1"
                        options={genders}
                        placeholder="Gender"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="relative mt-3 ">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Blood Group
                    </span>
                    <Form.Item name="bloodGroup ">
                      <Select
                        className="w-full rounded-md mt-1 text-xs"
                        placeholder="Blood Group"
                      >
                        {bloodgroup.map((option) => (
                          <Select.Option key={option} value={option}>
                            {option}
                          </Select.Option>
                        ))}
                      </Select>{" "}
                    </Form.Item>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Insurance No
                    </span>
                    <Form.Item name="insurance">
                      <Input
                        type="text"
                        placeholder="Insurance No"
                        className="w-full mt-1 rounded-md px-4 py-2 text-xs"
                      />{" "}
                    </Form.Item>
                  </div>
                </Col>
              </>
            )}
          </Row>
        </div>
        <div className="flex justify-between mx-3 ">
          <p className="">Appointment Details</p>
          <div className="">
            <span
              className="px-2 text-[#189FAA] cursor-pointer"
              onClick={() => {
                setShowFields2(!showFields2);
              }}
            >
              {!showFields2 ? "More" : "Hide"}
            </span>
          </div>
        </div>
        <div className="rounded-lg bg-white mx-3">
          <Row gutter={24} className="">
            <Col span={8}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-[#A0A2A3] text-xs">
                  Appointment Date <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="appointmentDate"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter appointmentDate!",
                    },
                  ]}
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    defaultValue={dayjs()}
                    className="w-full mt-1 rounded-md px-4 py-2 text-xs"
                    disabledDate={disabledDate}
                    placeholder="Appointment Date"
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={8}>
              <div className="relative mt-3">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                  Service Type <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="serviceCode"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Consultation Type!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={"APPT_VIDEO"}
                    showSearch={false}
                    className="w-full text-xs"
                    placeholder="Search to Consltations"
                    onChange={handleCallTypeChange}
                    placement=" Service Type"
                  >
                    +<Select.Option value="APPT_VIDEO">Video</Select.Option>
                    <Select.Option value="APPT_INPERSON">
                      In-Person
                    </Select.Option>
                    <Select.Option value="APPT_HOMEVISIT">
                      Home Visit
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </Col>
            <Col span={8}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                  Start Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="startTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Start Time!",
                    },
                  ]}
                >
                  <TimePicker
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-md px-4 py-2 text-xs"
                    onChange={handleStartTimeChange}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={8}>
              <div className="relative mt-3">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                  End Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="endTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter End Time!",
                    },
                  ]}
                >
                  <TimePicker
                    id="endTime"
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-md text-xs px-4 py-2"
                    value={endTime}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col className={`${showFields2 ? "block" : "hidden"}`} span={8}>
              <div className="relative mt-4">
                <span className="absolute -top-2 z-10 left-2 bg-white px-1 text-[#A0A2A3] text-xs">
                  Reason
                </span>
                <Form.Item name="consultationReason">
                  <div>
                    <Input
                      placeholder="Reason"
                      value={consReason}
                      onChange={handleConsReasonChange}
                      className={`rounded-md`}
                    />

                    {consultationReasonList.length > 0 && (
                      <ul className="absolute top-12 left-0 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20">
                        {consultationReasonList.map((reason, index) => (
                          <li
                            onClick={() => handleConsSelectChange(reason)}
                            key={index}
                            className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                          >
                            {reason.chiefComplaint}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Form.Item>
              </div>
            </Col>
            <Col className={`${showFields2 ? "block" : "hidden"}`} span={8}>
              <div className="relative mt-4">
                <span className="absolute -top-2 z-10 left-2 bg-white px-1 text-[#A0A2A3] text-xs">
                  Fees
                </span>
                <Form.Item
                  name="consultationFee"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Total Amount!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Amount"
                    className="rounded-md text-xs"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>
        <div className="mt-2 mx-4">
          <span>Payment Details</span>
        </div>
        <div className="bg-white rounded-lg  p-3 mt-5 ">
          <Row gutter={24}>
            <Col span={8}>
              <div className="relative mt-2">
                <span className="absolute -top-2 z-10 left-2 px-1  ">
                  Payment
                </span>
                <Form.Item
                  name="paymentConsultation"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Payment Consultation!",
                    },
                  ]}
                >
                  <Radio.Group
                    className="mt-5 text-xs"
                    disabled={
                      paymentType === "Cash" ||
                      paymentType === "VirtualCash" ||
                      paymentType === "Digital"
                        ? true
                        : false
                    }
                  >
                    <Radio value="BC" className="text-black text-xs">
                      Before
                    </Radio>
                    <Radio value="AC" className="text-black text-xs">
                      After
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </Col>

            <Col span={8}>
              <div className="relative mt-2">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                  Payment Type <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="paymentType"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Payment Type!",
                    },
                  ]}
                >
                  <Select
                    value={paymentType}
                    className="w-full text-xs text-[#A0A2A3]"
                    placeholder="Search to Payment mode"
                    onChange={onPaymentTypeChange}
                  >
                    <Select.Option
                      className="text-[#A0A2A3] text-xs"
                      value="Cash"
                    >
                      Cash
                    </Select.Option>
                    <Select.Option
                      className="text-[#A0A2A3] text-xs"
                      value="Digital"
                    >
                      Digital Payment
                    </Select.Option>
                    {/* <Select.Option
                      className="text-[#A0A2A3] text-xs"
                      value="VirtualCash"
                    >
                      Virtual Cash
                    </Select.Option> */}
                  </Select>{" "}
                </Form.Item>
                {paymentType == "Cash" && (
                  <>
                    <Col>
                      <Form.Item name="">
                        <div className="mt-3 text-[#A0A2A3] text-xs">
                          <Checkbox
                            checked={paymentReceived}
                            className="mr-3 text-[#A0A2A3] text-xs"
                            onChange={onPaymentStatusChange}
                          />
                          Payment Received
                        </div>
                      </Form.Item>
                    </Col>
                  </>
                )}
                {paymentType == "VirtualCash" && (
                  <div className="mt-3 text-[#A0A2A3] text-xs flex gap-2 font-semibold">
                    <span className=" text-black">Wallet Balance :</span>{" "}
                    <span className="text-blue-400">{walletAmount}</span>
                  </div>
                )}
              </div>
            </Col>
            <Col span={8}>
              {/* {applyRegFee && ( */}
              <div className="relative mt-2">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1 text-[#A0A2A3] rounded-md  text-xs">
                  Registration Fees
                </span>
                <Form.Item name="patientRegFee">
                  <Input
                    disabled={!applyRegFee}
                    className="w-full"
                    placeholder="Registration Fees"
                  />
                </Form.Item>
              </div>
              {/* )} */}
              {accountDetails.patientRegFeeYN === "Y" && (
                <Form.Item name="patientRegFeeYN">
                  <div className="w-40 flex gap-2 ">
                    <Checkbox
                      checked={applyRegFee}
                      className="text-xs text-[#A0A2A3] "
                      onChange={onFeeCheckBoxChage}
                    />
                    <p className="mt-3 text-[#A0A2A3] text-xs">
                      Registration Fees
                    </p>
                  </div>
                </Form.Item>
              )}
            </Col>
          </Row>
        </div>
        <Form.Item>
          <div className="flex gap-2 justify-end mt-2 mr-3">
            <button
              className="border rounded-lg bg-white text-sm w-20 text-[#189FAA]"
              onClick={handleCancelClick}
            >
              Cancel
            </button>
            {paymentType == "Digital" ? (
              <>
                <button
                  className="bg-brand-primaryColor border rounded-lg  w-40 p-2 text-sm text-white"
                  type="primary"
                  disabled={save}
                  htmlType="submit"
                  onClick={() => handleSubmitType("3")}
                >
                  Share Payment Link
                </button>
                <button
                  className="border rounded-lg bg-brand-primaryColor w-28 text-white"
                  type="primary"
                  disabled={save}
                  htmlType="submit"
                  onClick={() => handleSubmitType("1")}
                >
                  {callType === "APPT_VIDEO" ? "Pay Now" : "Pay & Schedule"}
                </button>
                {/* <button
                  className="border rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button> */}
              </>
            ) : (
              <>
                <button
                  className="border bg-brand-primaryColor rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button>
              </>
            )}
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default NewPatientInvite;
